module.exports = __webpack_public_path__ + "static/media/Copyright_page-0001.1a7ae7ce.jpg";